// Translation: Interface > Copy button (English)
export default Object.freeze({
	idle: 'Copy',
	success: 'Copied'
})
